
const BASE_URL =
  process.env.REACT_APP_ENV === 'production'
    ? 'https://claya-ruby-b715fff96163.herokuapp.com'
    : 'https://claya-stage-ruby-03e61b6e8c6b.herokuapp.com';

export const login = async (email, password) => {
  try {
    const response = await fetch(`${BASE_URL}/api/v1/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        user: {
          email,
          password,
        },
      }),
    });

    if (!response.ok) {
      throw new Error('Login failed');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchAppointments = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/v1/patients/appointments`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch appointments');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getTimeSlots = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/v1/patients/availabilities`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch appointments');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const bookAppointment = async (userId, date, time) => {
  const requestBody = {
    user_id: userId,
    datetime: `${date} ${time} +0530`,
  };

  try {
    const response = await fetch(`${BASE_URL}/api/v1/patients/appointments`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      throw new Error('Failed to book appointment');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error booking appointment:', error);
    throw error;
  }
};

// Reschedule appointment
export const rescheduleAppointment = async (appointmentId, userId, date, time) => {
  const requestBody = {
    user_id: userId,
    datetime: `${date} ${time} +0530`,
    pm_status: 'Re-Scheduled',
  };

  try {
    const response = await fetch(`${BASE_URL}/api/v1/patients/appointments/${appointmentId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      throw new Error('Failed to reschedule appointment');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error rescheduling appointment:', error);
    throw error;
  }
};

export const createNewPatient = async (firstName, lastName, email, phone, isSubscribed, productCategory, uuid) => {
  const requestBody = {
    first_name: firstName,
    last_name: lastName,
    email: email,
    phone_number: phone,
    email_subscribed: isSubscribed,
    product_category: productCategory,
    uuid
  };

  try {
    const response = await fetch(`${BASE_URL}/api/v1/patients/account_details`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });
    return response;  
  } catch (error) {
    console.error('Error booking appointment:', error);
    throw error;  
  }
};

export const findExistPatient = async (encodedEmail, productCategory) => {
  try {
    const response = await fetch(`${BASE_URL}/api/v1/patients/account_details/find_user?email=${encodedEmail}&product_category=${productCategory}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateExistingPatient = async (email, dob, gender, height, weight, city, line1, line2, state, zip, phone_number, productCategory, uuid) => {
  const requestBody = {
    email,
    dob,
    gender,
    height,
    weight,
    city,
    line1,
    line2,
    state,
    zip,
    phone_number,
    product_category: productCategory ,
    uuid
  };

  try {
    const response = await fetch(`${BASE_URL}/api/v1/patients/account_details/update_user_weight`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      throw new Error('Failed to update patient details');
    }

    const data = await response.json();
    return data; 
  } catch (error) {
    console.error('Error updating patient details:', error);
    throw error; 
  }
};

export const createSupplementUser = async (first_name,last_name, email, phone_number, line1, line2, city, state, zip, uuid) => {
  const requestBody = {
    first_name,
    last_name,
    email,
    phone_number,
    line1,
    line2,
    city,
    state,
    zip,
    uuid
  };

  try {
    const response = await fetch(`${BASE_URL}/api/v1/patients/account_details/create_supplement_user`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      throw new Error('Failed to create supplement user');
    }

    const data = await response.json();
    return data; 
  } catch (error) {
    console.error('Failed to create supplement user:', error);
    throw error; 
  }
};


export const updateWeight = async (id, weight,uuid) => {
  const requestBody = {
    user_id:id,
    weight,
    uuid
  };

  try {
    const response = await fetch(`${BASE_URL}/api/v1/patients/account_details/update_user_weight`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      throw new Error('Failed to update patient details');
    }

    const data = await response.json();
    return data; 
  } catch (error) {
    console.error('Error updating patient details:', error);
    throw error; 
  }
};

export const getPatientIntakeForm = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/v1/patients/intake_forms/get_intake_form`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch appointments');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getPersonalInfoForm = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/v1/patients/intake_forms/personal_info_form`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch appointments');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const submitIntakeForm = async (formAnswers, userEmail,productCatergory,uuid) => {
  const requestBody = {
    data: formAnswers, 
    user_email: userEmail,
    product_category: productCatergory,
    uuid
  };

  try {
    const response = await fetch(`${BASE_URL}/api/v1/patients/forms/submit_form`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      throw new Error('Failed to submit intake form');
    }

    const data = await response.json();
    return data; 
  } catch (error) {
    console.error('Error submitting intake form:', error);
    throw error; 
  }
};

export const getStripeProducts = async (productId) => {
  try {
    const response = await fetch(`${BASE_URL}/api/v1/stripe_products/get_product_prices?product=${productId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch appointments');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const supplementChargeBundle = async (code,bundle_price_id,email, first_name, last_name,phone_number, payment_method_id, customer_id) => {
  const requestBody = {
    promo_code: code,  
    bundle_price_id,
    email,
    first_name,
    last_name,
    phone_number,
    payment_method_id,
    customer_id
  };

  try {
    const response = await fetch(`${BASE_URL}/api/v1/patients/payments/charge_bundle`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      throw new Error('Failed to charge bundle');
    }

    const data = await response.json();
    return data;  
  } catch (error) {
    console.error('Error charging bundle:', error);
    throw error;  
  }
};

export const validateCoupon = async (code,amount, productId) => {
  const requestBody = {
    coupon_code: code,  
    amount,
    product_id: productId
  };

  try {
    const response = await fetch(`${BASE_URL}/api/v1/patients/payments/validate_coupon`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      throw new Error('Failed to validate coupon');
    }

    const data = await response.json();
    return data;  
  } catch (error) {
    console.error('Error validating coupon:', error);
    throw error;  
  }
};

export const createInvoice = async (userId, price, user_email) => {
  const requestBody = {
    user_id: userId,
    price: price,
    user_email: user_email
  };

  try {
    const response = await fetch(`${BASE_URL}/api/v1/patients/payments/create_payment_invoice`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      throw new Error('Failed to create invoice');
    }

    const data = await response.json();
    return data;  
  } catch (error) {
    console.error('Error create invoice:', error);
    throw error;  
  }
};

export const recordPaymentFailure = async (user_email) => {
  const requestBody = {
    user_email: user_email
  };

  try {
    const response = await fetch(`${BASE_URL}/api/v1/patients/payments/record_payment_failure`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      throw new Error('Something went wrong');
    }

    const data = await response.json();
    return data;  
  } catch (error) {
    console.error('Something went wrong:', error);
    throw error;  
  }
};

export const saveTokenToTelescope = async (token, email) => {
  const requestBody = {
    token: token,
    email: email
  };

  try {
    const response = await fetch(`${BASE_URL}/api/v1/patients/account_details/save_auth_token_to_telescope`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      throw new Error('Failed to create invoice');
    }

    const data = await response.json();
    return data;  
  } catch (error) {
    console.error('Something went wrong:', error);
    throw error;  
  }
};

export const imageUploadApi = async (file) => {
const formData = new FormData();
formData.append('q2_patient_image_url', file);

  try {
    const response = await fetch(`${BASE_URL}/api/v1/upload_image`, {
      method: 'POST',
      body: formData
    });

    if (!response.ok) {
      throw new Error('Failed to upload image');
    }

    const data = await response.json();
    return data; 
  } catch (error) {
    console.error('Error uploading image url:', error);
    throw error; 
  }
};
